import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PrdispatchPage } from '../features/prdispatch/PrdispatchPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PrdispatchPage />,
  },
  {
    path: '*',
    element: <Navigate to='/' replace />,
  },
]);
